package com.siriusxm.pia.views.unifiedaggregator.editor

import androidx.compose.runtime.*
import com.siriusxm.pia.components.DialogField
import com.siriusxm.pia.components.DialogView
import com.siriusxm.pia.components.ServiceViewContext
import com.siriusxm.pia.components.serviceContentView
import com.siriusxm.pia.rest.unifiedaggregator.asEntities
import com.siriusxm.pia.views.unifiedaggregator.rememberAggregator
import com.siriusxm.pia.views.unifiedaggregator.smithy.SmithyViewer
import com.siriusxm.pia.views.unifiedaggregator.smithy.aggregatorOptions
import com.siriusxm.pia.views.unifiedaggregator.typeSelect
import contentingestion.unifiedmodel.EntityType
import contentingestion.unifiedmodel.entityId
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.buildJsonObject

@Composable
fun ServiceViewContext.EntityEditor(id: entityId? = null) {
    val app = rememberAggregator()
    val aggregatorService by app.aggregatorContext()
    var entity by remember { mutableStateOf<com.siriusxm.pia.rest.unifiedaggregator.Entity?>(null) }
    var edited by remember { mutableStateOf(buildJsonObject { }) }
    var type by remember { mutableStateOf<EntityType?>(null) }

    LaunchedEffect(id) {
        if (id != null) {
            val loadedEntities = app.aggregator.getEntityById(id).asEntities()
            entity = loadedEntities.maxByOrNull { it.version }
            edited = entity?.data ?: buildJsonObject { }
            type = entity?.type?.let {
                EntityType.fromName(it)
            }
        }
    }

    serviceContentView({
        breadcrumbs {
            crumb("Aggregator", "aggregator")
            crumb("Publish", null)
        }
    }) {
        DialogView({
            title = if (id == null) "Publish Entity" else "Publish Entity Update"
        }) {
            if (id == null) {
                DialogField("Type") {
                    aggregatorService?.typeSelect(listOfNotNull(type), 1) {
                        type = it.firstOrNull()
                    }
                }
            }

            if (type != null && aggregatorService != null) {
                val model = aggregatorService?.entityModel

                val shape = aggregatorService?.entityType(type!!.name)?.shapeId?.let {
                    model?.getShape(it)
                }

                if (shape != null) {
                    val viewOptions = aggregatorOptions(aggregatorService!!)
                    val viewer = SmithyViewer(
                        shape,
                        viewOptions
                    ) {
                        edited = it as? JsonObject ?: buildJsonObject { }
                    }
                    viewer?.edit(entity?.data, edited, viewOptions)
                }
            }
        }
    }
}